<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <div class="header-content">
        <div class="header-title">
          <h2>Clientes</h2>
          <p>Gerencie seus clientes</p>
        </div>
        <b-button class="BtnRegister" @click="openModalToReceive">
          <div class="btn-icon">
            <b-icon-plus scale="1.2"></b-icon-plus>
          </div>
          <span>Novo Cliente</span>
        </b-button>
      </div>
    </div>

    <transition name="slide-fade">
      <div v-if="showFilters" class="mobile-filters-container">
        <div class="filter-row">
          <b-form-select
            v-model="type"
            :style="
              showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
            "
            :options="filterCombobox"
            @change="handleShowFilterTypes"
            size="sm"
            class="mobile-select"
          ></b-form-select>
        </div>

        <div class="filter-row search-row">
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar..."
            class="mobile-search-input"
            @keyup.enter="handleSearch"
          ></b-input>
          <b-button @click="handleSearch" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </transition>

    <div class="status-scroll-container">
      <div class="status-card clients-card">
        <div class="status-icon">
          <b-icon-people-fill scale="1.2"></b-icon-people-fill>
        </div>
        <div class="status-info">
          <span class="status-count">{{ this.counter.customersCount }}</span>
          <span class="status-label">Clientes</span>
        </div>
      </div>
      <div class="status-card properties-card">
        <div class="status-icon">
          <b-icon-geo-alt-fill scale="1.2"></b-icon-geo-alt-fill>
        </div>
        <div class="status-info">
          <span class="status-count">{{ this.counter.propertiesCount }}</span>
          <span class="status-label">Propriedades</span>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <b-button class="btn-toggle-filters" @click="showFilters = !showFilters">
        <b-icon-funnel-fill></b-icon-funnel-fill>
      </b-button>
    </div>
    <div v-if="loadingList" class="list-loading-state">
      <b-spinner class="list-loading-spinner"></b-spinner>
      <span>Carregando clientes...</span>
    </div>

    <div v-else class="card-list-container">
      <div
        v-for="customer in customers"
        :key="customer.id"
        class="customer-card"
        @click.stop="detailsCliente(customer)"
      >
        <div class="card-header-mobile">
          <div class="customer-id">
            <b-icon-person-circle class="customer-avatar"></b-icon-person-circle>
            <div class="id-info">
              <span class="customer-code">#{{ customer.codigo }}</span>
              <span class="customer-cpf">{{ customer.cpfCnpj || "000.000.00-00" }}</span>
            </div>
          </div>
          <div class="card-actions">
            <b-button
              variant="link"
              class="action-btn delete-btn"
              @click.stop="handleOpenModal(customer.id)"
            >
              <b-icon-trash scale="0.9"></b-icon-trash>
            </b-button>
          </div>
        </div>

        <div class="card-body-mobile">
          <div class="customer-info">
            <h4 class="customer-name">{{ customer.nome || "CONSUMIDOR FINAL" }}</h4>
            <div class="contact-info">
              <div class="contact-item">
                <b-icon-telephone class="contact-icon"></b-icon-telephone>
                <span class="contact-text">{{ customer.celular || "(00) 0000-0000" }}</span>
                <img
                  v-if="customer.celular"
                  class="whatsapp-btn"
                  :src="whatsapp"
                  @click.stop="redirectWhatsApp(customer.celular)"
                  title="Abrir WhatsApp"
                />
              </div>
            </div>
          </div>
        </div>
        
        <div class="card-footer">
          <div class="customer-status active">
            <span>Cliente Ativo</span>
          </div>
        </div>
      </div>

      <div v-if="!customers.length" class="empty-state">
        <b-icon-inbox scale="2"></b-icon-inbox>
        <p>Nenhum cliente encontrado.</p>
      </div>
    </div>

    <div v-if="customers.length" class="pagination-section">
      <b-button
        class="pagination-btn"
        :disabled="page === 1 || loadingList"
        @click="previousPage"
        size="lg"
        variant="outline-secondary"
      >
        <b-icon-chevron-left></b-icon-chevron-left>
        Anterior
      </b-button>

      <span class="pagination-page">{{ paginationLabel }}</span>

      <b-button
        class="pagination-btn"
        :disabled="this.dataLength < 9 || loadingList"
        @click="nextPage"
        size="lg"
        variant="outline-secondary"
      >
        Próxima
        <b-icon-chevron-right></b-icon-chevron-right>
      </b-button>
    </div>

    <ModalConfirm
      modalName="modal-confirm-delete"
      title="Remover Cliente"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="destroyCustomer"
      @modalClosed="selectedCustomerId = null"
    />
  </div>
</template>
<script>
import searchCustomer from "../../../mixins/Customer/Search";
import { mapMutations, mapState } from "vuex";
import serviceCustomer from "../../../services/serviceCustomer";
import api from "../../../services/axios";
import whatsapp from "../../../assets/whatsapp.svg";
import serviceRegisters from "../../../services/serviceRegisters";

export default {
  props: {
    getAllCustomer: {
      type: Boolean,
    },
  },
  mixins: [searchCustomer],

  data() {
    return {
      counter: {},
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      customers: [],
      page: 1,
      whatsapp: whatsapp,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "includes",
      showFilterTypes: false,
      showFilters: false,
      totalPages: 1,
      totalItems: 0,
      perPage: 9,
      loadingList: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
    ]),
    async findById(client) {
      try {
        const result = await serviceCustomer.findById(client.id);
        this.openModalToReceive(result);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    // async findCustomerSales() {
    //   this.customerSales = await serviceSale.findCustomerSales(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    // async findCustomerBills() {
    //   this.customerBills = await serviceBill.findCustomerBills(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    async detailsCliente(client) {
      try {
        const result = await serviceCustomer.findById(client.id);

        this.openModalDetails(result);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },
    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      this.startDate = "";
      this.endDate = "";
    },
    async readCustomers(page = 1) {
      try {
        this.loadingList = true;
        this.spinGeneral = true;

        const { data } = await api.get(
          `/customers?q=${encodeURIComponent(this.textPesquisa)}&type=${this.type}&page=${page}&filterType=${this.filterType || ""}`,
        );

        const items = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : Array.isArray(data?.data?.data)
          ? data.data.data
          : [];

        const meta = data?.meta || data?.pagination || data?.data?.meta || {};

        this.page = page;
        this.dataLength = items.length;
        this.customers = items;

        const resolvedTotalItems = Number(
          meta.total || data?.total || data?.data?.total || 0,
        );
        const fallbackTotalItems = this.hasActiveFilters
          ? (page - 1) * this.perPage +
            (items.length >= this.perPage ? this.perPage + 1 : items.length)
          : Number(this.counter?.customersCount || 0);

        this.totalItems = resolvedTotalItems || fallbackTotalItems || items.length;

        const resolvedTotalPages = Number(
          meta.last_page ||
            meta.totalPages ||
            data?.last_page ||
            data?.totalPages ||
            data?.data?.last_page ||
            0,
        );

        this.totalPages =
          resolvedTotalPages ||
          (this.totalItems ? Math.ceil(this.totalItems / this.perPage) : this.page);
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.loadingList = false;
        this.spinGeneral = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.readCustomers(1);
    },
    nextPage() {
      if (!this.canGoNext) return;
      this.readCustomers(this.page + 1);
    },
    previousPage() {
      if (this.page === 1) return;
      this.readCustomers(this.page - 1);
    },
    openModalToReceive(customers) {
      this.SET_DATA_SEARCH_FROM_CUSTOMER(customers);

      const name = "customer";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    openModalDetails(detailsCustomer) {
      this.SET_DATA_SEARCH_FROM_CUSTOMER(detailsCustomer);

      this.ALTER_TYPE_REGISTER("customer");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },

    handleShowFilterTypes() {
      const types = ["nome", "cpfCnpj", "celular", "endereco", "cidade", "cep"];

      this.page = 1;

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },
    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();

        if (!this.hasActiveFilters) {
          this.totalItems = Number(this.counter?.customersCount || 0);
          this.totalPages = this.totalItems
            ? Math.ceil(this.totalItems / this.perPage)
            : 1;
        }
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
    hasActiveFilters() {
      return Boolean(this.textPesquisa || this.type || this.filterType !== "includes");
    },
    canGoNext() {
      if (this.totalPages > this.page) {
        return true;
      }

      return this.dataLength >= this.perPage;
    },
    paginationLabel() {
      if (this.totalPages > this.page || this.totalPages > 1) {
        return `Página ${this.page} de ${this.totalPages}`;
      }

      return `Página ${this.page}`;
    },
  },
  watch: {
    async getAllCustomer() {
      this.page = 1;
      await this.readCustomers(1);
    },
    isSearchRegisters() {
      this.readCustomers(this.page);
    },
    filterType() {
      this.page = 1;
    },
  },
  created() {
    this.countAll();
  },
};
</script>
<style scoped>
.mobile-header {
  padding: 20px;
  width: 100%;
  background: linear-gradient(135deg, #006256 0%, #709e8a 100%);
  color: white;
  box-shadow: 0 8px 32px rgba(0, 98, 86, 0.3);
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.header-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.header-title p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.BtnRegister {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  color: #006256;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.BtnRegister:hover, .BtnRegister:focus {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  color: #006256;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.btn-icon {
  width: 24px;
  height: 24px;
  background: #006256;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 5px 20px;
  background: rgba(0, 98, 86, 0.05);
}

.btn-toggle-filters {
  background: white;
  color: #006256;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 44px;
  height: 44px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn-toggle-filters:hover {
  background: #006256;
  color: white;
  transform: scale(1.05);
}

.mobile-filters-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.filter-row {
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 0;
}

.mobile-search-input {
  flex: 1;
  border-radius: 12px;
  height: 44px;
  border: 2px solid #e9ecef;
  padding: 0 16px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-search-input:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006256, #709e8a);
  border: none;
  border-radius: 12px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.3);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 98, 86, 0.4);
}

.status-scroll-container {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(0, 98, 86, 0.03), rgba(112, 158, 138, 0.03));
}

.status-card {
  flex: 1;
  background: white;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.clients-card {
  border-left: 4px solid #006256;
}

.properties-card {
  border-left: 4px solid #709e8a;
}

.status-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.clients-card .status-icon {
  background: linear-gradient(135deg, #006256, #709e8a);
}

.properties-card .status-icon {
  background: linear-gradient(135deg, #709e8a, #8bb4a3);
}

.status-info {
  display: flex;
  flex-direction: column;
}

.status-count {
  font-size: 18px;
  font-weight: 700;
  color: #006256;
  margin: 0;
}

.status-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-list-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.customer-card {
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.customer-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #006256, #709e8a);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.customer-card:active {
  transform: scale(0.98);
}

.customer-card:hover::before {
  transform: scaleY(1);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 0 16px;
}

.customer-id {
  display: flex;
  align-items: center;
  gap: 12px;
}

.customer-avatar {
  font-size: 32px;
  color: #006256;
}

.id-info {
  display: flex;
  flex-direction: column;
}

.customer-code {
  font-weight: 700;
  color: #006256;
  font-size: 14px;
}

.customer-cpf {
  font-size: 12px;
  color: #6c757d;
  font-family: 'Monaco', 'Menlo', monospace;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.delete-btn {
  color: #dc3545;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.card-body-mobile {
  padding: 0 16px 16px 16px;
}

.customer-info {
  padding-left: 44px;
}

.customer-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 8px 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-icon {
  color: #006256;
  font-size: 14px;
}

.contact-text {
  font-size: 14px;
  color: #4a5568;
  flex: 1;
}

.whatsapp-btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 4px;
}

.whatsapp-btn:hover {
  transform: scale(1.1);
}

.card-footer {
  padding: 8px 16px;
  background: rgba(0, 98, 86, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.customer-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.customer-status.active {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.customer-status.active::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.empty-state {
  text-align: center;
  color: #a0aec0;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

.list-loading-state {
  text-align: center;
  color: #a0aec0;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.list-loading-spinner {
  color: #006256;
}

.pagination-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  gap: 12px;
}

.pagination-btn {
  flex: 1;
  min-width: 100px;
  padding: 12px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s;
}

.pagination-btn:disabled {
  opacity: 0.3;
}

.pagination-page {
  font-size: 1rem;
  font-weight: 700;
  color: #495057;
  white-space: nowrap;
  padding: 0 8px;
}

.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.status-scroll-container::-webkit-scrollbar {
  display: none;
}

.mobile-select {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  height: 44px;
  font-size: 16px;
  padding: 0 16px;
  transition: all 0.3s ease;
}

.mobile-select:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

@media (max-width: 380px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  
  .status-scroll-container {
    flex-direction: column;
  }

  .pagination-section {
    padding: 16px 20px 24px;
  }
  
  .customer-name {
    font-size: 16px;
  }
}
</style>